$(document).ready(function () {
  var menuItems = $(".header__inline-menu ul li");

  menuItems.each(function (index) {
    var nthChild = index + 1;

    $(document).on(
      "mouseenter",
      ".header__inline-menu ul li:nth-child(" + nthChild + ")",
      function (event) {
        jQuery(".main-menu-item .main-menu-dropdown").removeClass("show-menu");

        $(".menu-" + nthChild).addClass("show-menu");
      }
    );

    $(document).on("mouseleave", ".header-wrapper", function () {
      $(".main-menu-item .main-menu-dropdown").removeClass("show-menu");
    });
  });
});

// Show the first tab and hide the rest
//main-menu-dropdown
$(".tab-sub-menus li:first-child").addClass("active");
$(".main-menu-dropdown:first-child .tab-content").hide();
$(".main-menu-dropdown:first-child .tab-content:first").show();

$(".main-menu-dropdown:nth-child(2) .tab-content").hide();
$(".main-menu-dropdown:nth-child(2) .tab-content:first").show();

// Click function
$(".tab-sub-menus li").mouseenter(function () {
  $(this)
    .parents(".main-menu-dropdown")
    .find(".tab-sub-menus li")
    .removeClass("active");
  // $(this).addClass('active');
  $(this).parents(".main-menu-dropdown").find(".tab-content").hide();

  var activeTab = $(this).find("a").attr("href");
  console.log("activeTab: ", activeTab);
  // $(activeTab)?.fadeIn();
  $(activeTab)?.show();
  return false;
});
